import productApi from '@/api/product'

export default {
  namespaced: true,
  
  state: {
    products: [],
    total: 0,
    currentProduct: null
  },
  
  mutations: {
    SET_PRODUCTS(state, { items, total }) {
      state.products = items
      state.total = total
    },
    SET_CURRENT_PRODUCT(state, product) {
      state.currentProduct = product
    }
  },
  
  actions: {
    // 获取商品列表
    async getProducts({ commit }, params) {
      try {
        const result = await productApi.getProducts(params)
        commit('SET_PRODUCTS', result)
        return result
      } catch (error) {
        console.error('Failed to get products:', error)
        throw error
      }
    },
    
    // 保存商品
    async saveProduct({ dispatch }, data) {
      try {
        await productApi.saveProduct(data)
        // 刷新列表
        await dispatch('getProducts', {})
      } catch (error) {
        console.error('Failed to save product:', error)
        throw error
      }
    },
    
    // 获取商品详情
    async getProduct({ commit }, id) {
      try {
        const product = await productApi.getProduct(id)
        commit('SET_CURRENT_PRODUCT', product)
        return product
      } catch (error) {
        console.error('Failed to get product:', error)
        throw error
      }
    }
  },
  
  getters: {
    productList: state => state.products,
    productTotal: state => state.total,
    currentProduct: state => state.currentProduct
  }
} 